import React from "react";
import { Menu } from "antd";

const SidebarItems = ({
  items = [],
  onClick = () => {},
  theme = "dark",
  // collapsed = "true",
  selectedkeys
}) => {

  const menuItems = (items) => {
    return items.map((item) => {
        const { children = [] } = item;

        const MenuComponent = (m) => ({
          key: m.key,
          icon: m.icon,
          onClick: onClick,
          label: (
              <span style={{ color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {m.label}
              </span>
          ),
        })

            if (children && children.length) {
                return {
                    ...MenuComponent(item),
                    children: menuItems(children),
                };
            }

            return MenuComponent(item);
        });
};
  
  return (
    <Menu
      theme={theme}
      selectedkeys={[selectedkeys]}
      // onClick={onClick}
      mode='inline'
      style={{
        height: "calc(90vh - 68px)", // Minus the logo height
        overflowY: "auto",
        background: "transparent"
      }}
      items={menuItems(items)}
      trigger={null}
    />
  );
};

export default SidebarItems;
